module.exports = __webpack_public_path__ + "static/media/profile-email.6dee224c.svg";